var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartySeller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 15.75V3.75C3 3.35218 3.15804 2.97064 3.43934 2.68934C3.72064 2.40804 4.10218 2.25 4.5 2.25H10.5C10.8978 2.25 11.2794 2.40804 11.5607 2.68934C11.842 2.97064 12 3.35218 12 3.75V15.75",
    strokeWidth: 1.425,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#0D44AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 6.75H13.5C13.8978 6.75 14.2794 6.90804 14.5607 7.18934C14.842 7.47064 15 7.85218 15 8.25V15.75M15 15.75H2.25M15 15.75H15.75M6 5.25H9M6 8.25H9M6 11.25H9",
    strokeWidth: 1.425,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#0D44AD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartySeller);
export default __webpack_public_path__ + "static/media/party-seller.6d7f120103ead1f596c07ad955557c11.svg";
export { ForwardRef as ReactComponent };